/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Link } from "@chakra-ui/react";
import { useState, useEffect, useCallback, useRef } from "react";
import { useRouter } from "next/router";
import { GetCookie, SetCookie } from "../provider/common";
import styles from "./as9120PopUp.module.css";

const DRAG_THRESHOLD = 5;

export default function As9120PopUp() {
  const router = useRouter();
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 137 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const mouseDownPos = useRef({ x: 0, y: 0 });
  const isDrag = useRef(false);
  const date = new Date();
  const today = date.toISOString().slice(0, 10);

  const closeToday = async () => {
    await SetCookie("closeAs9120PopUpDate", today);
    setVisible(false);
  };

  const handleMouseDown = (e) => {
    mouseDownPos.current = { x: e.clientX, y: e.clientY };
    isDrag.current = false;
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = useCallback(
    (e) => {
      if (!dragging) return;
      const dx = Math.abs(e.clientX - mouseDownPos.current.x);
      const dy = Math.abs(e.clientY - mouseDownPos.current.y);
      if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) isDrag.current = true;
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    },
    [dragging, offset],
  );

  const handleMouseUp = useCallback(() => {
    setDragging(false);
  }, []);

  const handleImageClick = () => {
    if (isDrag.current) return;
    router.push("/board/board_view?no=100&type=notice");
  };

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, handleMouseMove, handleMouseUp]);

  useEffect(async () => {
    const theDay = await GetCookie("closeAs9120PopUpDate");
    if (theDay !== today) {
      setVisible(true);
    }
  }, []);

  return (
    <>
      <Box
        className={styles.popUp}
        style={{ left: position.x, top: position.y }}
      >
        {visible ? (
          <>
            <Box className={styles.popUp_close_left}>
              <Link onClick={() => setVisible(false)}>X</Link>
            </Box>
            <Box
              className={styles.popUp_box}
              onMouseDown={handleMouseDown}
              style={{ cursor: dragging ? "grabbing" : "grab" }}
            >
              <img
                src="./images/popup/as9120popup.png"
                width="316"
                height="429"
                draggable="false"
                onClick={handleImageClick}
                style={{ cursor: "pointer", display: "block" }}
              />
            </Box>
            <Box className={styles.popUp_txt_bottom}>
              <input
                type="checkbox"
                onClick={closeToday}
                style={{ cursor: "pointer" }}
              />
              <Link onClick={closeToday}>오늘 하루 열지 않기</Link>
            </Box>
          </>
        ) : (
          ""
        )}
      </Box>
    </>
  );
}
